#!/usr/bin/env node

import { init } from "./commands/init";
import { Command } from "commander";
import { update } from "./commands/update";
import { sync } from "./commands/sync";

process.on("SIGINT", () => process.exit(0));
process.on("SIGTERM", () => process.exit(0));

async function main() {
  const program = new Command()
    .name("@kinesys/design")
    .description("initialize kinesys design system");

  program
    .addCommand(init) // init command is for initializing the design system
    .addCommand(update) // update command is for updating the design system
    .addCommand(sync); // sync command is for syncing the design system to the package

  program.parse();
}

main();
